/* Guides: on Meet the Guides the species chips narrow the cards, which
   keep the order the section rendered (Order setting first, then by
   name). On a guide page a video poster opens the video large in an
   overlay on the page, never on YouTube (Abdul, 2026-10-14); Escape, the
   close button or the backdrop closes it and focus returns to the poster. */
(function () {
  'use strict';
  if (window.__caGuides) return;
  window.__caGuides = true;
  document.querySelectorAll('[data-ca-guides]').forEach(function (root) {
    var grid = root.querySelector('[data-ca-guide-grid]');
    var chipsBox = root.querySelector('[data-ca-guide-chips]');
    var count = root.querySelector('[data-ca-guide-count]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ca-guide-card]'));
    cards.sort(function (a, b) {
      var ra = Number(a.getAttribute('data-ca-guide-rank')), rb = Number(b.getAttribute('data-ca-guide-rank'));
      if (ra !== rb) return ra - rb;
      return (a.getAttribute('data-ca-guide-name') || '').localeCompare(b.getAttribute('data-ca-guide-name') || '');
    });
    cards.forEach(function (c) { grid.appendChild(c); });
    function has(card, value) { return (' ' + (card.getAttribute('data-ca-guide-chips') || '') + ' ').indexOf(' ' + value + ' ') >= 0; }
    var chip = 'all';
    function show() {
      var n = 0;
      cards.forEach(function (c) { var on = chip === 'all' || has(c, chip); c.hidden = !on; if (on) n += 1; });
      if (count) count.textContent = n + (n === 1 ? ' guide' : ' guides');
    }
    if (chipsBox) {
      var any = false;
      chipsBox.querySelectorAll('[data-ca-guide-chip]').forEach(function (b) {
        var v = b.getAttribute('data-ca-guide-chip');
        if (v === 'all') return;
        var found = cards.some(function (c) { return has(c, v); });
        b.hidden = !found;
        if (found) any = true;
      });
      chipsBox.hidden = !any;
      chipsBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ca-guide-chip]');
        if (!b) return;
        chip = b.getAttribute('data-ca-guide-chip');
        chipsBox.querySelectorAll('[data-ca-guide-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        show();
      });
    }
    show();
  });

  // Video overlay
  var box = null;
  var opener = null;
  function closeVideo() {
    if (!box) return;
    box.remove();
    box = null;
    document.body.classList.remove('ca-guide-lightbox-open');
    document.removeEventListener('keydown', onKey);
    if (opener) opener.focus();
  }
  function onKey(e) { if (e.key === 'Escape') closeVideo(); }
  function openVideo(btn) {
    var id = btn.getAttribute('data-ca-guide-video');
    if (!id) return;
    closeVideo();
    opener = btn;
    box = document.createElement('div');
    box.className = 'ca-guide-lightbox' + (btn.hasAttribute('data-ca-guide-short') ? ' ca-guide-lightbox--short' : '');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', btn.getAttribute('data-ca-guide-title') || 'Video');
    var panel = document.createElement('div');
    panel.className = 'ca-guide-lightbox__panel';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ca-guide-lightbox__close';
    close.setAttribute('aria-label', 'Close video');
    close.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    frame.title = btn.getAttribute('data-ca-guide-title') || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.setAttribute('allowfullscreen', '');
    var title = document.createElement('p');
    title.className = 'ca-guide-lightbox__title';
    title.textContent = btn.getAttribute('data-ca-guide-title') || '';
    panel.appendChild(close);
    panel.appendChild(frame);
    panel.appendChild(title);
    box.appendChild(panel);
    box.addEventListener('click', function (e) { if (e.target === box) closeVideo(); });
    close.addEventListener('click', closeVideo);
    document.body.appendChild(box);
    document.body.classList.add('ca-guide-lightbox-open');
    document.addEventListener('keydown', onKey);
    close.focus();
    try { if (window.clarity) window.clarity('event', 'ca_guide_play_video'); } catch (err) {}
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ca-guide-video]');
    if (!btn) return;
    e.preventDefault();
    openVideo(btn);
  });
})();
